import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Shared/Navigation/Navigation";
import DashboardView from "./components/Shared/Dashboard/DashboardView";
import CompanyProfile from "./components/Company/profile/CompanyProfile";
import EmployeeView from "./components/Employee/EmployeeDetailView/EmployeeView";
import AuthView from "./components/Auth/AuthView";
import Home from "./components/Home/Home";
import AboutUs from "./components/AboutUs/AboutUs";
import JobPosts from "./components/Jobs/JobPosts/JobPosts";
import JobDetail from "./components/Jobs/JobDetail/JobDetail";
import Apply from "./components/Jobs/JobApplication/Apply/Apply";
import Footer from "./components/Shared/Footer";
import PasswordReset from "./components/Auth/PasswordReset";
import GoogleCallback from "./components/Auth/GoogleCallback";
import CompanyListView from "./components/Company/list/CompanyListView";
import { AuthProvider } from "./context/AuthContext";
import { GoogleMapsProvider } from "./context/GoogleMapsContext";
import { RestaurantProvider } from "./context/RestaurantContext";
import Dashboard from "./components/DashboardMetrics/Dashboard";
import ProtectedAdminRoute from "./components/ProtectedRoute/ProtectedRoute";
import ScrollToTop from "./components/Shared/ScrollToTop";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AppContent = () => {
  const [active, setActive] = useState("");
  const location = useLocation();

  // Track page views
  useEffect(() => {
    if (window.gtag) {
      // TODO: Mover a .env file
      window.gtag('config', 'G-FHBEXLYESH', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <>
      <ScrollToTop />
          <header>
            <Navigation active={active} setActive={setActive} />
          </header>
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/nosotros" element={<AboutUs />} />
              <Route path="/trabajos" element={<JobPosts />} />
              <Route path="/trabajos/:id" element={<JobDetail />} />
              <Route path="/trabajos/:id/aplicar" element={<Apply />} />
              <Route path="/empresas" element={<CompanyListView />} />
              <Route path="/empresas/:id" element={<CompanyProfile />} />
              <Route path="/empleados/:id" element={<EmployeeView />} />
              <Route path="/perfil-empleado" element={<EmployeeView />} />
              <Route
                path="/metricas-dashboard"
                element={
                  <ProtectedAdminRoute>
                    <Dashboard />
                  </ProtectedAdminRoute>
                }
              />
              <Route path="/perfil-empresa" element={<CompanyProfile />} />
              <Route
                path="/panel-empleado/*"
                element={<DashboardView userType={"employee"} />}
              />
              <Route
                path="/panel-empresa/*"
                element={<DashboardView userType={"company"} />}
              />
              <Route path="/postula" element={<Apply />} />
              <Route
                path="/profesionales/entrar"
                element={
                  <AuthView isSignUp={false} userType={"profesionales"} />
                }
              />
              <Route
                path="/profesionales/crear"
                element={
                  <AuthView isSignUp={true} userType={"profesionales"} />
                }
              />
              <Route
                path="/empresas/entrar"
                element={<AuthView isSignUp={false} userType={"empresas"} />}
              />
              <Route
                path="/empresas/crear"
                element={<AuthView isSignUp={true} userType={"empresas"} />}
              />
              <Route path="/reset-password" element={<PasswordReset />} />
              <Route path="/set-password" element={<PasswordReset />} />
              <Route path="/panel-empresa/confirm-email" element={<PasswordReset />} />
              <Route path="/auth/callback" element={<GoogleCallback />} />
            </Routes>
          </main>
      <Footer />
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <RestaurantProvider>
        <GoogleMapsProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </GoogleMapsProvider>
      </RestaurantProvider>
    </AuthProvider>
  );
};

export default App;
